import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const autoSettingsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'exchangeCurrencyFromId',
    label: 'From',
  },
  {
    name: 'exchangeCurrencyToId',
    label: 'To',
  },
  {
    name: 'rateSourceLifetimeSeconds',
    label: 'Rate lifetime',
  },
  {
    name: 'maxAmountCurrencyId',
    label: 'Exchange Type',
  },
  {
    name: 'minAmountPerOperation',
    label: 'Min per operation',
  },
  {
    name: 'maxAmountPerOperation',
    label: 'Max per operation',
  },
  {
    name: 'maxAmountForPeriod',
    label: 'Max for period',
  },
  {
    name: 'maxAmountPeriodInHours',
    label: 'Period (days)',
  },
  {
    name: 'targetStatus',
    label: 'Target status',
  },
  {
    name: 'active',
    label: 'Status',
  },
];

export const autoSettingsListColumnsLabels = {
  exchangeCurrencyToId: 'Currency to',
  active: 'Status',
};

export const autoSettingsListAllColumnsLabels = {
  exchangeCurrencyToId: 'Currency to',
  exchangeCurrencyFromId: 'Currency from',
  active: 'Status',
};

export const autoSettingsListDefaultSorter = {};

export const autoSettingsListSchema = {
  exchangeCurrencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const autoSettingsListAllSchema = {
  exchangeCurrencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  exchangeCurrencyFromId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const autoSettingsListFiltersSchema = [
  {
    name: 'exchangeCurrencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];

export const autoSettingsListAllFiltersSchema = [
  {
    name: 'exchangeCurrencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'exchangeCurrencyFromId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];
